import { useEffect, useState } from 'react';

const CONSENT_KEY = 'samolabs_consent_v1';

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);
  const [fadingOut, setFadingOut] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(CONSENT_KEY)) {
        // Kurz warten, damit der Banner nicht direkt beim Page-Load knallt
        const t = setTimeout(() => setVisible(true), 400);
        return () => clearTimeout(t);
      }
    } catch {
      // localStorage nicht verfügbar (z.B. private mode) → Banner nicht zeigen
    }
  }, []);

  function dismiss() {
    try {
      localStorage.setItem(
        CONSENT_KEY,
        JSON.stringify({ analytics: true, dismissed_at: Date.now() })
      );
    } catch {
      // ignore
    }
    setFadingOut(true);
    setTimeout(() => setVisible(false), 250);
  }

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Hinweis zur Reichweitenmessung"
      style={{
        position: 'fixed',
        right: 20,
        bottom: 20,
        width: 380,
        maxWidth: 'calc(100vw - 40px)',
        background: '#ffffff',
        border: '1px solid #e5e7eb',
        borderRadius: 12,
        boxShadow: '0 10px 30px rgba(15, 23, 42, 0.12), 0 2px 6px rgba(15, 23, 42, 0.06)',
        padding: 16,
        zIndex: 9999,
        fontFamily:
          'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        color: '#0f172a',
        opacity: fadingOut ? 0 : 1,
        transform: fadingOut ? 'translateY(8px)' : 'translateY(0)',
        transition: 'opacity 240ms ease, transform 240ms ease',
      }}
    >
      <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
        <div
          style={{
            flex: '0 0 auto',
            width: 36,
            height: 36,
            borderRadius: 8,
            background: '#eef2ff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#4f46e5',
          }}
          aria-hidden="true"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
          </svg>
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 14, lineHeight: 1.5 }}>
            <strong>Anonyme Reichweitenmessung</strong> &mdash; Diese Seite nutzt Plausible
            Analytics &mdash; self-hosted auf unseren Servern, ohne Cookies und ohne
            personenbezogene Daten.
          </div>
          <div style={{ marginTop: 6, fontSize: 13 }}>
            <a
              href="/datenschutz"
              style={{ color: '#4f46e5', textDecoration: 'underline' }}
            >
              Mehr in der Datenschutzerklärung
            </a>
          </div>
          <div style={{ marginTop: 12, display: 'flex', justifyContent: 'flex-end' }}>
            <button
              type="button"
              onClick={dismiss}
              style={{
                appearance: 'none',
                border: '1px solid #4f46e5',
                background: '#4f46e5',
                color: '#ffffff',
                fontSize: 13,
                fontWeight: 600,
                padding: '8px 14px',
                borderRadius: 8,
                cursor: 'pointer',
              }}
            >
              Verstanden
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
